module.exports = __webpack_public_path__ + "assets/img/btn-detail-e3ab06bf.png";